import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Sofa Set",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Upgrade your living area with our cozy and elegant Sofa Set. Designed for comfort and style, it's a perfect fit for modern homes and family spaces.",
        description: "Our Sofa Set features plush cushions, durable upholstery, and a solid wood frame for lasting quality. With a clean design and spacious seating, it's ideal for lounging, entertaining, or relaxing after a long day. The fabric is soft, breathable, and easy to clean—blending luxury with practicality.",
        category: ["Living Furniture", "Outdoor Furniture"],
        tags: ["sofa", "couch", "living"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Fabric & Solid Wood" },
            { id: 2, title: "Seating Capacity", content: "3-5 People" },
            { id: 3, title: "Color Options", content: "Gray, Navy, Beige" },
            { id: 4, title: "Care Instructions", content: "Spot clean with mild detergent" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Ava Mitchell",
                date: "Feb 18, 2025",
                rating: 5,
                content: "This sofa is both beautiful and comfortable. Definitely worth the price!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Oliver Hayes",
                date: "Feb 25, 2025",
                rating: 4.5,
                content: "Very cozy and fits well in our small living room. Delivery was smooth too."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Cutting Board",
        price: 50,
        disprice: 40,
        stock: 15,
        content: "Prepare meals with precision using our premium wooden Cutting Board. Ideal for slicing, dicing, and serving with a natural finish that complements any kitchen.",
        description: "Crafted from durable, food-safe hardwood, our Cutting Board offers a sturdy and stylish surface for everyday cooking. Its smooth edges, non-slip design, and natural grain make it both functional and attractive. Great for prepping fruits, vegetables, meats, and cheeses—this board is an essential for any home chef.",
        category: ["Kitchen Essentials", "Dining Furniture"],
        tags: ["board", "kitchen", "dining"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Natural Hardwood" },
            { id: 2, title: "Dimensions", content: "16 x 12 inches" },
            { id: 3, title: "Finish", content: "Smooth, Food-Safe Oil Coating" },
            { id: 4, title: "Care Instructions", content: "Hand wash only, air dry" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Lucas Bennett",
                date: "Mar 01, 2025",
                rating: 5,
                content: "Sturdy and beautiful! I use it every day. Looks great on the counter too."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Mia Collins",
                date: "Mar 05, 2025",
                rating: 4,
                content: "Nice finish and easy to clean. Would recommend for any home kitchen."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Dining Table",
        price: 50,
        disprice: 40,
        stock: 6,
        content: "Create memorable meals and gatherings around our elegant Dining Table. Designed with timeless style and durable craftsmanship for both daily use and special occasions.",
        description: "Made from solid hardwood and finished with a smooth, rich veneer, this Dining Table brings warmth and charm to any dining space. Its sturdy construction supports large family meals, while the minimalist design fits seamlessly in both classic and modern interiors. A perfect centerpiece for dining rooms or open kitchens.",
        category: ["Dining Furniture", "Living Furniture"],
        tags: ["table", "dining", "furniture"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Hardwood" },
            { id: 2, title: "Dimensions", content: "72 x 36 x 30 inches" },
            { id: 3, title: "Seating Capacity", content: "6-8 People" },
            { id: 4, title: "Finish", content: "Walnut or Oak Veneer" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Noah Carter",
                date: "Mar 12, 2025",
                rating: 5,
                content: "Looks beautiful in our dining room and feels super sturdy. Great value!"
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Sophia Green",
                date: "Mar 14, 2025",
                rating: 4.5,
                content: "Love the natural wood texture and solid feel. Delivery was on time too."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Picnic Table",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Enjoy outdoor dining and gatherings with our classic wooden Picnic Table. Built for durability and comfort, it's perfect for backyards, parks, and patios.",
        description: "Crafted from weather-resistant treated wood, this Picnic Table combines strength and simplicity. Its integrated bench seating and spacious tabletop accommodate family picnics, BBQs, or weekend hangouts. Easy to assemble and made to withstand the elements — it’s a staple for any outdoor space.",
        category: ["Outdoor Furniture", "Dining Furniture"],
        tags: ["table", "outdoor", "dining"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Pressure-Treated Wood" },
            { id: 2, title: "Dimensions", content: "60 x 30 x 28 inches" },
            { id: 3, title: "Seating Capacity", content: "4-6 People" },
            { id: 4, title: "Usage", content: "Outdoor Use Only" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Oliver Hayes",
                date: "Mar 18, 2025",
                rating: 5,
                content: "Perfect for our backyard! Easy to set up and very solid construction."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Amelia Ross",
                date: "Mar 20, 2025",
                rating: 4,
                content: "Great table for outdoor meals. Just added a coat of sealant for extra protection."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Table Lamps",
        price: 50,
        disprice: 40,
        stock: 12,
        content: "Add warmth and charm to any room with our stylish Table Lamps. Designed for both functionality and aesthetic appeal, they’re ideal for desks, bedside tables, and reading nooks.",
        description: "These Table Lamps feature a sleek base and soft fabric shade that diffuses light beautifully. Available in multiple finishes to match any décor, they’re energy-efficient and compatible with standard bulbs. Whether you're working late or setting a cozy mood, these lamps are your go-to lighting solution.",
        category: ["Lighting Accessories", "Living Furniture"],
        tags: ["lamp", "table", "lighting"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal Base, Fabric Shade" },
            { id: 2, title: "Height", content: "18 inches" },
            { id: 3, title: "Bulb Type", content: "E26 LED or Incandescent" },
            { id: 4, title: "Power Source", content: "Corded Electric" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Grace Miller",
                date: "Mar 22, 2025",
                rating: 4.5,
                content: "Looks elegant and gives off the perfect warm glow. Very satisfied with the purchase."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Henry Bennett",
                date: "Mar 24, 2025",
                rating: 4,
                content: "Nice design, easy to assemble. Works great on my nightstand."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Deck Chairs",
        price: 50,
        disprice: 40,
        stock: 9,
        content: "Relax in style with our comfortable and foldable Deck Chairs. Perfect for patios, balconies, gardens, or by the poolside, they bring a resort vibe to your outdoor space.",
        description: "Made with durable wooden frames and breathable fabric slings, these Deck Chairs offer both support and aesthetic appeal. Designed for easy storage and portability, they’re ideal for lounging under the sun or enjoying your favorite book. Weather-resistant and low maintenance — built for long-lasting outdoor leisure.",
        category: ["Outdoor Furniture", "Living Furniture"],
        tags: ["chair", "outdoor", "relax"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Frame Material", content: "Solid Wood" },
            { id: 2, title: "Fabric", content: "UV-Resistant Polyester" },
            { id: 3, title: "Foldable", content: "Yes" },
            { id: 4, title: "Weight Capacity", content: "250 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Noah Carter",
                date: "Mar 28, 2025",
                rating: 5,
                content: "Super comfy and easy to store away. Feels like a mini vacation every time I sit in it!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Ella Brooks",
                date: "Mar 30, 2025",
                rating: 4,
                content: "Great for lounging outside. Stylish and functional."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "File Cabinets",
        price: 50,
        disprice: 40,
        stock: 15,
        content: "Keep your workspace organized with our sleek and spacious File Cabinets. Designed for both home offices and professional environments, they provide secure and stylish storage.",
        description: "These File Cabinets feature multiple drawers with smooth glide mechanisms and secure lock options. Built from durable wood with a modern finish, they help you organize documents, supplies, and essentials. Their compact footprint makes them ideal for small spaces while maximizing storage capacity.",
        category: ["Living Furniture", "Dining Furniture"],
        tags: ["cabinet", "office", "storage"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Engineered Wood" },
            { id: 2, title: "Number of Drawers", content: "3" },
            { id: 3, title: "Lockable", content: "Yes" },
            { id: 4, title: "Dimensions", content: "30\" H x 16\" W x 20\" D" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Olivia Adams",
                date: "Apr 02, 2025",
                rating: 4.5,
                content: "Very sturdy and blends well with my office furniture. The locking feature is a bonus."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "James Foster",
                date: "Apr 04, 2025",
                rating: 4,
                content: "Plenty of space and good build quality. Keeps everything neatly filed."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Picture Frame",
        price: 50,
        disprice: 40,
        stock: 20,
        content: "Display your memories in style with our elegant Picture Frame. Perfect for photos, art prints, or certificates, it adds a personal touch to any space.",
        description: "Crafted from high-quality wood with a smooth finish, this Picture Frame features a clear glass front for protection and easy wall mounting or tabletop display. Its minimalist design complements both classic and contemporary interiors, making it a versatile decor piece for your home or office.",
        category: ["Living Furniture", "Lighting Accessories"],
        tags: ["frame", "decor", "wall"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Wood & Glass" },
            { id: 2, title: "Frame Size", content: "8\" x 10\"" },
            { id: 3, title: "Mount Type", content: "Wall & Tabletop" },
            { id: 4, title: "Color Options", content: "Black, White, Natural" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Sophia Bennett",
                date: "Apr 08, 2025",
                rating: 5,
                content: "Beautiful and well-made. My photo looks amazing in this frame!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Jackson Lee",
                date: "Apr 10, 2025",
                rating: 4.5,
                content: "Great quality for the price. I bought several for a gallery wall."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Hammock",
        price: 50,
        disprice: 40,
        stock: 12,
        content: "Relax in ultimate comfort with our durable and stylish Hammock. Ideal for outdoor lounging, it’s perfect for backyards, patios, or weekend camping trips.",
        description: "Crafted from breathable fabric and reinforced with sturdy ropes, this Hammock provides excellent support and comfort. It’s easy to set up between trees or on a stand, and the weather-resistant material ensures long-lasting outdoor use. Whether you're sunbathing, reading, or napping, it turns any space into a serene retreat.",
        category: ["Outdoor Furniture", "Living Furniture"],
        tags: ["hammock", "outdoor", "relax"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Cotton Blend" },
            { id: 2, title: "Weight Capacity", content: "450 lbs" },
            { id: 3, title: "Setup Type", content: "Tree or Stand" },
            { id: 4, title: "Dimensions", content: "110\" L x 55\" W" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Noah Carter",
                date: "Apr 15, 2025",
                rating: 5,
                content: "Super cozy and strong. My new favorite spot to unwind outdoors!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Grace Miller",
                date: "Apr 18, 2025",
                rating: 4.5,
                content: "Easy to hang and very relaxing. Great for sunny afternoons in the garden."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Couch Set",
        price: 50,
        disprice: 40,
        stock: 8,
        content: "Upgrade your living room with our comfortable and stylish Couch Set. Designed for maximum relaxation and aesthetic appeal, it suits modern and classic interiors alike.",
        description: "This Couch Set includes a spacious sofa and matching chairs, upholstered in soft, durable fabric with sturdy wooden frames. Its ergonomic design provides excellent support, while the sleek lines and neutral tones blend seamlessly into any decor. Perfect for family gatherings or cozy movie nights.",
        category: ["Living Furniture", "Outdoor Furniture"],
        tags: ["couch", "sofa", "living"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Fabric Upholstery" },
            { id: 2, title: "Seating Capacity", content: "5 Persons" },
            { id: 3, title: "Frame", content: "Solid Wood" },
            { id: 4, title: "Dimensions", content: "85\" L x 35\" W x 34\" H" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Ava Johnson",
                date: "Apr 20, 2025",
                rating: 5,
                content: "Super comfy and stylish! The perfect centerpiece for our living room."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Ethan Brown",
                date: "Apr 22, 2025",
                rating: 4.5,
                content: "Great quality and very comfortable. Looks fantastic in my home."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Chopping Board",
        price: 50,
        disprice: 40,
        stock: 25,
        content: "Prepare your meals with ease using our durable and hygienic Chopping Board. Designed to withstand heavy use, it’s perfect for every kitchen task.",
        description: "Made from high-quality, food-safe wood, this Chopping Board offers a smooth surface that protects your knives and resists stains and odors. Its sturdy construction ensures long-lasting performance, while the non-slip edges keep it secure during use. Ideal for chopping vegetables, meats, and more.",
        category: ["Kitchen Essentials", "Dining Furniture"],
        tags: ["board", "kitchen", "cutting"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Premium Hardwood" },
            { id: 2, title: "Dimensions", content: "18\" x 12\"" },
            { id: 3, title: "Thickness", content: "1.5 inches" },
            { id: 4, title: "Care", content: "Hand Wash Recommended" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Mia Roberts",
                date: "Apr 25, 2025",
                rating: 5,
                content: "Sturdy and well-made! Makes food prep a breeze."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Oliver Green",
                date: "Apr 27, 2025",
                rating: 4.5,
                content: "Great size and quality. Easy to clean and maintain."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Dinner Table",
        price: 50,
        disprice: 40,
        stock: 7,
        content: "Gather your family around our elegant Dinner Table, designed to offer both style and durability for everyday meals and special occasions.",
        description: "Crafted from solid wood with a smooth finish, this Dinner Table combines classic craftsmanship with modern design. Its spacious surface accommodates up to six people comfortably, making it perfect for family dinners and entertaining guests. Durable construction ensures it will be a centerpiece for years to come.",
        category: ["Dining Furniture", "Living Furniture"],
        tags: ["table", "dining", "furniture"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Wood" },
            { id: 2, title: "Seating Capacity", content: "6 Persons" },
            { id: 3, title: "Dimensions", content: "72\" L x 36\" W x 30\" H" },
            { id: 4, title: "Finish", content: "Matte Lacquer" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Sophia Lee",
                date: "May 01, 2025",
                rating: 5,
                content: "Beautiful and sturdy. It really completes our dining room."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "James Kim",
                date: "May 03, 2025",
                rating: 4.5,
                content: "Excellent quality and very comfortable for family meals."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Outdoor Table",
        price: 50,
        disprice: 40,
        stock: 15,
        content: "Enhance your outdoor space with our durable and stylish Outdoor Table, perfect for patios, gardens, and backyard gatherings.",
        description: "Constructed from weather-resistant materials, this Outdoor Table withstands the elements while maintaining its elegant look. Its spacious surface is ideal for meals, drinks, or casual get-togethers. Lightweight yet sturdy, it offers easy portability and long-lasting use.",
        category: ["Outdoor Furniture", "Dining Furniture"],
        tags: ["table", "outdoor", "patio"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Weather-Resistant Wood" },
            { id: 2, title: "Dimensions", content: "48\" L x 30\" W x 29\" H" },
            { id: 3, title: "Weight", content: "25 lbs" },
            { id: 4, title: "Care", content: "Wipe Clean with Damp Cloth" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Ella Martinez",
                date: "May 10, 2025",
                rating: 5,
                content: "Perfect for my patio! Durable and looks great."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Noah White",
                date: "May 12, 2025",
                rating: 4.5,
                content: "Sturdy and lightweight. Exactly what I needed."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Lamp Pair",
        price: 50,
        disprice: 40,
        stock: 20,
        content: "Illuminate your space with this elegant Lamp Pair, perfect for bedside tables, desks, or living rooms.",
        description: "Featuring a sleek design and warm light, this Lamp Pair adds a cozy ambiance to any room. Crafted with durable materials and stylish finishes, they complement various interior styles while providing functional lighting.",
        category: ["Lighting Accessories", "Living Furniture"],
        tags: ["lamp", "lighting", "decor"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal and Fabric" },
            { id: 2, title: "Height", content: "18 inches" },
            { id: 3, title: "Bulb Type", content: "LED (Included)" },
            { id: 4, title: "Power", content: "120V" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Grace Allen",
                date: "May 15, 2025",
                rating: 5,
                content: "Beautiful lamps, perfect size for my bedroom."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Ethan Brooks",
                date: "May 17, 2025",
                rating: 4.7,
                content: "Great light quality and very stylish design."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Lounge Chairs",
        price: 50,
        disprice: 40,
        stock: 12,
        content: "Relax in style with our comfortable and chic Lounge Chairs, designed to enhance your living or outdoor space.",
        description: "These Lounge Chairs feature ergonomic design and premium materials for maximum comfort. Perfect for indoor or outdoor use, their durable frames and soft cushions create a cozy spot for relaxation or socializing.",
        category: ["Outdoor Furniture", "Living Furniture"],
        tags: ["chair", "lounge", "relax"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Aluminum Frame" },
            { id: 2, title: "Cushion", content: "Weather-Resistant Fabric" },
            { id: 3, title: "Dimensions", content: "30\" W x 32\" D x 35\" H" },
            { id: 4, title: "Weight Capacity", content: "300 lbs" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Olivia Scott",
                date: "May 20, 2025",
                rating: 5,
                content: "Extremely comfortable and stylish. A great addition to my patio."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Mason Clark",
                date: "May 22, 2025",
                rating: 4.6,
                content: "Good quality and perfect for lounging outdoors."
            }
        ]
    }

];

export default products;